// Kohde- ja reittilistan haku ja suodattimet. Puhtaita funktioita: lista sisään, suodatettu lista ulos.
// Haku ei välitä isoista kirjaimista eikä ääkkösistä ("kuntorata", "Köyliö" ja "koylio" löytävät saman).

/** Pituusluokat reiteille (km). Raja kuuluu ylempään luokkaan. */
export const LENGTH_BANDS = [
  { id: "short", label: "Alle 2 km", min: 0, max: 2 },
  { id: "mid", label: "2–5 km", min: 2, max: 5 },
  { id: "long", label: "Yli 5 km", min: 5, max: Infinity },
];

export const EMPTY_FILTER = { query: "", municipality: "", length: "", difficulty: "", status: "", line: "" };

/** Pienet kirjaimet ilman ääkkösmerkkejä ja ylimääräisiä välilyöntejä. */
export function normalize(text) {
  return String(text ?? "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/\s+/g, " ")
    .trim();
}

/** Onko jokin suodatin käytössä? (Ilmoittaa käyttäjälle, että lista on rajattu.) */
export function filterActive(filter) {
  return Object.entries({ ...EMPTY_FILTER, ...filter }).some(([key, value]) => key in EMPTY_FILTER && String(value).trim() !== "");
}

/** Kunnat valintalistaa varten, aakkosjärjestyksessä. */
export function municipalitiesOf(list) {
  return [...new Set((list ?? []).map((x) => x.municipality).filter(Boolean))].sort((a, b) => a.localeCompare(b, "fi"));
}

const bandOf = (km) => !Number.isFinite(km) ? null : LENGTH_BANDS.find((b) => km >= b.min && km < b.max)?.id ?? null;

/**
 * Suodattaa kohteet tai reitit. Kaikki ehdot yhdessä (JA). Reitin pituus- ja vaativuussuodatin jättää pois reitit,
 * joiden tieto puuttuu: muuten "Helppo" näyttäisi myös reitit, joiden vaativuutta ei tiedetä.
 * status: "done" | "todo"; line: "yes" | "no" (reittilinja tai kohteen tarkka piste on olemassa).
 */
export function filterItems(list, kind, filter = {}) {
  const f = { ...EMPTY_FILTER, ...filter };
  const words = normalize(f.query).split(" ").filter(Boolean);
  return (list ?? []).filter((it) => {
    if (words.length) {
      const haystack = normalize(`${it.name} ${it.area ?? ""} ${it.municipality ?? ""}`);
      if (!words.every((w) => haystack.includes(w))) return false;
    }
    if (f.municipality && it.municipality !== f.municipality) return false;
    if (f.status === "done" && !it.state?.done) return false;
    if (f.status === "todo" && it.state?.done) return false;
    const located = kind === "routes" ? Boolean(it.has_geometry) : Boolean(it.has_location);
    if (f.line === "yes" && !located) return false;
    if (f.line === "no" && located) return false;
    if (kind === "routes") {
      if (f.length && bandOf(it.source_length_km) !== f.length) return false;
      if (f.difficulty && it.difficulty !== f.difficulty) return false;
    }
    return true;
  });
}
